import './../../assets/css/App.css';
import './../../assets/css/layout.css';
import './../../assets/css/global/components.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/ui/widgets/datepicker';
import React, { Component } from 'react';
import CountryHistogramByRevenue from './countryHistogramByRevenueView';
import PageTitle from './../../component/pageTitle'
import TableView from './tableView';

class Dashboard extends Component {
    render() {
        return (
            <div className="page-content-wrapper">
                <PageTitle pageTitle = {"Country Statistics Page"} ></PageTitle>
                <div className="page-content tabbable-custom column-xs-12">
                    <TableView></TableView>
                    <div className="graph-border-without-left-margin">
                        <CountryHistogramByRevenue></CountryHistogramByRevenue>
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;
